module.exports = __webpack_public_path__ + "asset/image-iconCategoryIncome-36f492813a2f448f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/iconCategoryIncome.svg
// module id = QmoE
// module chunks = 0